import { render, staticRenderFns } from "./SaleBackModal.vue?vue&type=template&id=34fa9a91&scoped=true"
import script from "./SaleBackModal.vue?vue&type=script&lang=js"
export * from "./SaleBackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa9a91",
  null
  
)

export default component.exports